import React from "react";

class Resume extends React.Component {
  render() {
    return (
      <div className="resume-page">
        <div id="Resume"></div>
        <br></br>
        <div className="full-resume-container animate fade-in-from-bottom">
          <iframe
            className="full-resume-content"
            title="Scott Kutler Resume"
            src="/Scott-Kutler-Resume.pdf"
          ></iframe>
        </div>
        <div className="resume-flex-grid">
          <a href="/Scott-Kutler-Resume.pdf" download="Scott-Kutler-Resume.pdf">
            <div className="FullResume">
              <span className="resume-button">Download Resume (PDF)</span>
            </div>
          </a>
        </div>
      </div>
    );
  }
}
export default Resume;
